import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import koKR from 'antd/es/locale/ko_KR';

import { store } from './Modules/Presentation/store';
import { initAuthThunk } from './Modules/User/Presentation/actions';
import { useAppDispatch } from './Modules/Presentation/hooks';

import AdminLayout from './Layouts/AdminLayout';
import AuthGate from './Routes/AuthGate';
import DashboardRoutes from './Routes/DashboardRoutes';
import NoticesRoutes from './Routes/NoticesRoutes';
import AccountsRoutes from './Routes/AccountsRoutes';
import SlotsRoutes from './Routes/SlotsRoutes';
import SlotsInactiveRoutes from './Routes/SlotsInactiveRoutes';
import LogsRoutes from './Routes/LogsRoutes';
import LoginRoutes from './Routes/LoginRoutes';
import MypageRoutes from './Routes/MypageRoutes';
import KeywordOptimizationRoutes from './Routes/KeywordOptimizationRoutes';
import UrlRankRoutes from './Routes/UrlRankRoutes';
import SlackNotifySettingsRoutes from './Routes/SlackNotifySettingsRoutes';
import SlotOpsTimeSettingsRoutes from './Routes/SlotOpsTimeSettingsRoutes';
import SettingsRoutes from './Routes/SettingsRoutes';

if (process.env.NODE_ENV === 'production') {
  const noop = () => {};

  const c = console as any;
  [
    'log', 'warn', 'error', 'info', 'debug', 'trace',
    'group', 'groupCollapsed', 'groupEnd',
    'table', 'time', 'timeEnd', 'assert'
  ].forEach((method) => {
    try { c[method] = noop; } catch (_) { /* ignore */ }
  });
}

const InitAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  useEffect(() => { dispatch(initAuthThunk()); }, [dispatch]);
  return <>{children}</>;
};

const App: React.FC = () => (
  <Provider store={store}>
    <ConfigProvider locale={koKR}>
      <BrowserRouter>
        <InitAuth>
          <Routes>
            {/* ▼ 로그인 전용 라우트 */}
            <Route path="/login" element={<LoginRoutes />} />

            {/* ▼ 보호된(인증 필요) 섹션 */}
            <Route element={<AuthGate />}>
              <Route path="/" element={<AdminLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<DashboardRoutes />} />
                <Route path="notices" element={<NoticesRoutes />} />
                <Route path="accounts" element={<AccountsRoutes />} />
                <Route path="slots" element={<SlotsRoutes />} />
                <Route path="slots-inactive" element={<SlotsInactiveRoutes />} />
                <Route path="logs" element={<LogsRoutes />} />
                <Route path="slack-notify-settings" element={<SlackNotifySettingsRoutes />} />
                <Route path="slot-ops-time-settings" element={<SlotOpsTimeSettingsRoutes />} />
                <Route path="settings" element={<SettingsRoutes />} />
                <Route path="profile" element={<MypageRoutes />} />
                <Route path="keyword-optimization" element={<KeywordOptimizationRoutes />} />
                <Route path="url-rank" element={<UrlRankRoutes />} />
              </Route>
            </Route>

            {/* ▼ 잘못된 주소 → 홈으로 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </InitAuth>
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);

export default App;
